import {NgxsOnChanges, NgxsOnInit, NgxsSimpleChange, Selector, State, StateContext} from "@ngxs/store";
import {Injectable} from "@angular/core";
import {PlansModel} from "../_models/plans.model";


export const _PlansDefault: PlansModel = {
  list: [
    /*MATH & ELA*/
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUpeRQqYCP",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 12.99,
        "total": 40,
        "sale": 12.99
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUgRBDyzE5",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 9.99,
        "total": 369,
        "sale": 119.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUKfcfalhk",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 3.99,
        "total": 1539,
        "sale": 499.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUk4Coj3aj",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 15.59,
        "total": 48,
        "sale": 15.59
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUXtXaFkQi",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 11.99,
        "total": 443,
        "sale": 143.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUscIMj5xk",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 4.80,
        "total": 1847,
        "sale": 599.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILU3bMM02yw",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 18.19,
        "total": 56,
        "sale": 18.19
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUxDjYjqFl",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 13.99,
        "total": 517,
        "sale": 167.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUqv0Hi0q6",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 5.60,
        "total": 2155,
        "sale": 699.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUmNRthM25",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 20.78,
        "total": 64,
        "sale": 20.78
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUW4zVRP6Y",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 16,
        "total": 591,
        "sale": 191.98
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUgeFmuc9P",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 6.40,
        "total": 2463,
        "sale": 799.98
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    /*MATH & ELA & SCIENCE*/
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1R40AvEy2I3xqILUNL4XKpiF",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 12.99,
        "science_per_month": 4.99,
        "total": 55,
        "sale": 17.98
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUaWTOSgZ3",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 10,
        "science_per_month": 4.98,
        "total": 553,
        "sale": 179.76
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUdYVNvpKC",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 4,
        "science_per_month": 1.60,
        "total": 2155,
        "sale": 699.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILU1tvo0qHj",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 15.59,
        "science_per_month": 4.79,
        "total": 63,
        "sale": 20.38
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILULJDkaJHI",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 12,
        "science_per_month": 5.98,
        "total": 664,
        "sale": 215.71
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUrpUwcAL7",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 4.80,
        "science_per_month": 1.92,
        "total": 2586,
        "sale": 839.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUkKiUQz26",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 18.19,
        "science_per_month": 5.58,
        "total": 73,
        "sale": 23.77
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUAigSeDFY",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 14,
        "science_per_month": 6.97,
        "total": 775,
        "sale": 251.66
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUMfv7HA7h",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 5.60,
        "science_per_month": 2.24,
        "total": 3017,
        "sale": 979.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUCT2ALR6d",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 20.78,
        "science_per_month": 6.39,
        "total": 84,
        "sale": 27.17
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILU9EOSifSe",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 16,
        "science_per_month": 7.97,
        "total": 886,
        "sale": 287.62
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUlWiDwvf5",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 6.40,
        "science_per_month": 2.56,
        "total": 3448,
        "sale": 1119.98
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    /*MATH & ELA & SOCIAL STUDIES*/
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R1pxDEy2I3xqILUFiS3iJU1",
      "children": 1,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 12.99,
        "social_studies_per_month": 4.99,
        "total": 55,
        "sale": 17.98
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R1pzCEy2I3xqILUppAQbauN",
      "children": 1,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 10,
        "social_studies_per_month": 4.98,
        "total": 553,
        "sale": 179.76
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R1q1BEy2I3xqILUXzL41vtS",
      "children": 1,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 4,
        "social_studies_per_month": 1.60,
        "total": 2155,
        "sale": 699.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40DJEy2I3xqILUP9s6Vfh4",
      "children": 2,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 15.59,
        "social_studies_per_month": 4.79,
        "total": 63,
        "sale": 20.38
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40HDEy2I3xqILU9BnhMDle",
      "children": 2,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 12,
        "social_studies_per_month": 5.98,
        "total": 664,
        "sale": 215.71
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40IVEy2I3xqILUX86ViTXm",
      "children": 2,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 4.80,
        "social_studies_per_month": 1.92,
        "total": 2586,
        "sale": 839.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 3,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 18.19,
        "social_studies_per_month": 5.58,
        "total": 73,
        "sale": 23.77
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 3,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 14,
        "social_studies_per_month": 6.97,
        "total": 775,
        "sale": 251.66
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 3,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 5.60,
        "social_studies_per_month": 2.24,
        "total": 3017,
        "sale": 979.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 4,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 20.78,
        "social_studies_per_month": 6.39,
        "total": 84,
        "sale": 27.17
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 4,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 16,
        "social_studies_per_month": 7.97,
        "total": 886,
        "sale": 287.62
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 4,
      "subject": "math_ela_social_studies",
      "cost": {
        "per_month": 6.40,
        "social_studies_per_month": 2.56,
        "total": 3448,
        "sale": 1119.98
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },

    /*MATH & ELA & SCIENCE & SOCIAL STUDIES*/
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40JhEy2I3xqILUgm1T6kpd",
      "children": 1,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 12.99,
        "science_per_month": 4.99,
        "social_studies_per_month": 4.99,
        "total": 71,
        "sale": 22.97,

      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40KbEy2I3xqILUKp5QvxmB",
      "children": 1,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 10,
        "science_per_month": 4.98,
        "social_studies_per_month": 4.98,
        "total": 738,
        "sale": 239.53,
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40LjEy2I3xqILUOCYsBkb7",
      "children": 1,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 4,
        "science_per_month": 1.60,
        "social_studies_per_month": 1.60,
        "total": 2771,
        "sale": 899.99,
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40MiEy2I3xqILUneAFifzk",
      "children": 2,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 15.59,
        "science_per_month": 4.79,
        "social_studies_per_month": 4.79,
        "total": 77,
        "sale": 25.17,
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40NoEy2I3xqILUMowUdfka",
      "children": 2,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 12,
        "science_per_month": 5.98,
        "social_studies_per_month": 5.98,
        "total": 885,
        "sale": 287.43,
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "price_1R40OnEy2I3xqILUniKZy5EU",
      "children": 2,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 4.80,
        "science_per_month": 1.92,
        "social_studies_per_month": 1.92,
        "total": 3325,
        "sale": 1079.99,
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 3,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 18.19,
        "science_per_month": 5.58,
        "social_studies_per_month": 5.58,
        "total": 90,
        "sale": 29.35,
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 3,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 14,
        "science_per_month": 6.97,
        "social_studies_per_month": 6.97,
        "total": 1032,
        "sale": 335.33,
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 3,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 5.60,
        "science_per_month": 2.24,
        "social_studies_per_month": 2.24,
        "total": 3880,
        "sale": 1259.99,
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 4,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 20.78,
        "science_per_month": 6.39,
        "social_studies_per_month": 6.39,
        "total": 103,
        "sale": 33.56,
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 4,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 16,
        "science_per_month": 7.97,
        "social_studies_per_month": 7.97,
        "total": 1180,
        "sale": 383.26,
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188",
        "60117829c42dc65bb0280ec2",
        "600fee7e07ccd63b3941ab1b",
        "602b92be36f38e64e140fb87",
        "61307ef37a982f347b0e28d2",
        "62ea2a2e2cfa664c3f202697",
        "6012ce7cc42dc65bb0280eea",
        "601d2b72577ab36754330754",
        "633d88c83afb350a0d60c06e",
        "6790be5333b01c627c935402",
        "6790e36533b01c627c935c41",
        "67935f3657801a8b5ee08743",
        "679b321dbbd7c116c27d1552",
        "67af1557cc106d338758487f",
        "67af319fcc106d3387584d72",
        "67b43a9ccc106d33875a149b",
        "67b487c3cc106d33875a35ae",
        "67bc23b840c0596c8daee937",
        "67bc27d440c0596c8daeeaf1"
      ],
      "stripe": "",
      "children": 4,
      "subject": "math_ela_science_social_studies",
      "cost": {
        "per_month": 6.40,
        "science_per_month": 2.56,
        "social_studies_per_month": 2.56,
        "total": 4434,
        "sale": 1439.98,
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science & Social Studies",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },


    /*SHSAT*/
    {
      "exam": "shsat",
      "featured": false,
      "period": "halfyear",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QgnpAEy2I3xqILUW9iHAKvg",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 41.66,
        "total": 400,
        "sale": 249.99
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "You will get unlimited access to all our premium video lectures, practice questions, and quizzes.",
      "button_text": "TRY FOR FREE"
    },
    {
      "exam": "shsat",
      "featured": true,
      "period": "year",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QgnpAEy2I3xqILU7dmt3UHn",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 33.33,
        "total": 600,
        "sale": 399.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "You will save 20% by choosing this plan, and get unlimited access to all our premium video lectures, practice questions, and quizzes. This is a great balance between price and access time.",
      "button_text": "TRY FOR FREE"
    },
    {
      "exam": "shsat",
      "featured": false,
      "period": "month",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QgnpAEy2I3xqILUoY62Au7Q",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 49.99,
        "total": 70,
        "sale": 49.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "This plan is for those who love to have access on demand. You will get unlimited access to all our premium video lectures, practice questions, and quizzes. A great option for those who focus on goals and get things done.",
      "button_text": "TRY FOR FREE"
    }
  ]
};

@State<PlansModel>({
  name: 'V04_APO_PLANS',
  defaults: _PlansDefault,
})
@Injectable()
export class PlansState implements NgxsOnInit, NgxsOnChanges {

  constructor() {}

  ngxsOnInit(ctx?: StateContext<any>): any {}
  ngxsOnChanges(change: NgxsSimpleChange<PlansModel>): void {}


  @Selector()
  static selectPlans( state: PlansModel) {
    return state.list;
  }
}
